<template>
  <v-container
    tag="section"
  >
    <base-material-card
      color="coolrunner"
      icon="book"
      inline
      class="px-5 py-3"
    >
      <template
        v-slot:after-heading
      >
        <div class="text-h2 font-weight-light">
          {{ $t('quickpay') }} {{ $t('subscription') }} | {{ entity.created_at }}
        </div>
      </template>
      <v-row class="justify-end">
        <v-btn
          color="coolrunner"
          @click="load(true)"
        >
          <v-icon class="mr-3">
            replay
          </v-icon>

          {{ $t('sync') }} {{ $t('quickpay') }}
        </v-btn>
      </v-row>
      <v-container class="py-0">
        <v-row>
          <v-col
            cols="6"
          >
            <base-material-card
              color="coolrunner"
              inline
              class="px-5 py-3"
              :title="$t('payments')"
            >
              <v-data-table
                :headers="paymentsHeaders"
                :items="payments"
                :options.sync="paymentsOptions"
                :server-items-length="totalPayments"
                :loading="loading"
                dense
                class="elevation-0"
              >
                <template v-slot:item.amount="{ item }">
                  {{ item.amount.toFixed(2) }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn
                    text
                    icon
                    color="green"
                    :to="'/payments/quickpay/creditcard/'+item.id"
                    target="_blank"
                  >
                    <v-icon>open_in_new</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </base-material-card>
          </v-col>
          <v-col
            cols="6"
          >
            <base-material-card
              color="coolrunner"
              inline
              class="px-5 py-3"
              :title="$t('information')"
            >
              <v-data-iterator
                hide-default-footer
                dense
                :items="[information]"
              >
                <template v-slot:default="props">
                  <v-row>
                    <v-col
                      cols="12"
                    >
                      <v-list dense>
                        <template
                          v-for="(info, index) in information"
                        >
                          <v-list-item
                            v-if="info.val"
                            :key="index"
                            style="max-height: 30px; min-height: 30px;"
                          >
                            <v-list-item-content>
                              {{ info.title }}:
                            </v-list-item-content>
                            <v-list-item-content
                              class="align-end"
                            >
                              {{ info.val || '-' }}
                            </v-list-item-content>
                            <v-list-item-content
                              class="align-end"
                            >
                              <v-btn
                                v-if="info.copy"
                                v-clipboard:copy="info.val"
                                icon
                                small
                              >
                                {{ $t('copy') }}
                              </v-btn>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-list>
                    </v-col>
                  </v-row>
                </template>
              </v-data-iterator>
            </base-material-card>
          </v-col>

          <v-col cols="6">
            <base-material-card
              color="coolrunner"
              inline
              class="px-5 py-3"
              :title="$t('operations')"
            >
              <v-expansion-panels
                accordion
                flat
              >
                <v-expansion-panel
                  v-for="(operation, i) in vendor_information.operations "
                  :key="i"
                >
                  <v-expansion-panel-header>{{ formatQpDate(operation.created_at) }} {{ entity.currency }} {{ (operation.amount / 100).toFixed(2) }} {{ operation.type }}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              {{ $t('type') }}
                            </th>
                            <th class="text-left">
                              {{ $t('amount') }}
                            </th>
                            <th class="text-left">
                              {{ $t('acquirer') }}
                            </th>
                            <th class="text-left">
                              {{ $t('acquirer') }} {{ $t('status') }}
                            </th>
                            <th class="text-left">
                              {{ $t('quickpay') }} {{ $t('status') }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{{ operation.type }}</td>
                            <td>{{ entity.currency }} {{ (operation.amount / 100).toFixed(2) }}</td>
                            <td>{{ operation.acquirer }}</td>
                            <td>{{ operation.aq_status_msg }}</td>
                            <td>{{ operation.qp_status_msg }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </base-material-card>
          </v-col>
          <v-col cols="6">
            <base-material-card
              color="coolrunner"
              inline
              class="px-5 py-3"
              :title="$t('actions')"
            >
              <v-col cols="12">
                <v-subheader class="pl-0">
                  {{ $t('cancel') }}
                </v-subheader>
                <v-btn
                  color="coolrunner"
                  :disabled="locked || entity.balance_id || entity.vendor_information.balance === 0"
                  @click="cancel"
                >
                  {{ $t('cancel') }} {{ $t('subscription') }}
                </v-btn>
              </v-col>
            </base-material-card>
          </v-col>
          <v-col cols="6">
            <base-material-card
              color="coolrunner"
              inline
              class="px-5 py-3"
              :title="$t('vendor_data')"
            >
              <v-row class="justify-end">
                <v-btn
                  v-clipboard:copy="JSON.stringify(entity.vendor_information, null, 4)"
                  color="green"
                  class="ml-auto"
                >
                  {{ $t( 'copy') }}
                </v-btn>
              </v-row>
              <v-textarea
                disabled
                :rows="JSON.stringify(entity.vendor_information, null, 4).split(/[\r\n]/).length"
                :value="JSON.stringify(entity.vendor_information, null, 4)"
              />
            </base-material-card>
          </v-col>
        </v-row>
      </v-container>
    </base-material-card>
    <base-loading-overlay :loading="loading" />
  </v-container>
</template>
<script>
  import { URL_PREFIX } from '@/utils/constants'
  import { handleErrorResponse } from '@/plugins/data'

  import Edit from '@/mixins/Edit'

  export default {
    mixins: [Edit],
    data () {
      return {
        endpoint: 'payments/quickpay/subscriptions',
        name: 'payment',

        params: {
          with: ['customer'],
        },
        paymentsOptions: {},
        payments: [],
        totalPayments: 0,
        entity: { vendor_information: { message: 'dummy' }, metadata: {}, customer: {} },
        locked: false,
        refundAmount: null,
        paymentsHeaders: [
          {
            sortable: false,
            text: this.$t('id'),
            value: 'transaction_id',
            width: '100%',
          },
          {
            sortable: false,
            text: this.$t('amount'),
            value: 'amount',
          },
          {
            sortable: false,
            text: this.$t('state'),
            value: 'state',
          },
          {
            sortable: false,
            text: this.$t('created'),
            value: 'created_at',
          },
          {
            sortable: false,
            text: this.$t('actions'),
            value: 'actions',
            align: 'right',
          },
        ],
      }
    },
    computed: {
      vendor_information: function () {
        if (this.entity.vendor_information && !this.entity.vendor_information.message) { return this.entity.vendor_information }

        return {
          metadata: {
            exp_month: '',
            exp_year: '',
            brand: '',
          },
          operations: [],
        }
      },
      information: function () {
        return {
          subscription_id: { title: this.$t('subscription_id'), val: this.entity.subscription_id, copy: true },
          customer: { title: this.$t('customer'), val: `${this.entity.customer.name} ${this.entity.customer.business ? this.entity.customer.company_name : ''}`, copy: true },
          card_type: { title: this.$t('card_type'), val: this.vendor_information.metadata.brand },
          card_number: { title: this.$t('card_number'), val: this.formatCard(this.entity.card_number) },
          expired: { title: this.$t('expired'), val: `${`${this.vendor_information.metadata.exp_month}`}/${this.vendor_information.metadata.exp_year + ''.substr(2, 2)}` },
        }
      },
      insurances: function () {
        if (!this.entity.order) { return [] }

        return this.$_.filter(this.entity.order.order_lines, ['orderable_type', 'insurance'])
      },
      paymentsParams: function () {
        return {
          limit: this.paymentsOptions.itemsPerPage,
          page: this.paymentsOptions.page,
          filters: this.filter,
        }
      },
      subscription_id: function () {
        return this.$route.query.subscription_id || this.$route.params.id
      },
    },
    watch: {
      paymentsParams: {
        handler () {
          this.loadPayments()
        },
        deep: true,
      },
    },
    methods: {
      load (refresh) {
        if (!this.$route.params || !this.canRead()) { return }

        this.loading = true
        this.$get(`${this.endpoint}/${this.subscription_id}`, { ...this.params, refresh: refresh })
          .then(response => {
            this.entity = response.data

            this.loading = false
            this.loadPayments()

            refresh && this.$toast(`${this.$t('payment')} ${this.$t('synced')}`)
          })
          .catch(() => {
            refresh && this.$toast(`${this.$t('payment')} ${this.$t('not')} ${this.$t('synced')}`)

            this.loading = false
          })
      },
      loadPayments () {
        this.loading = true
        this.$get(`${this.endpoint}/${this.subscription_id}/payments`, this.paymentsParams)
          .then(response => {
            this.totalPayments = response.data.total
            this.payments = response.data.data
            this.loading = false
          })
          .catch(() => {
            this.payments = []
            this.$toast(`${this.$t('could_not')} ${this.$t('load')} ${this.$t('payments')}`)

            this.loading = false
          })
      },
      insuranceById: function (id) {
        return this.$_.find(this.insurances, ['id', id]) || this.$t('no')
      },
      getCustomerId: function () {
        const possibilities = [
          this.entity.order ? this.entity.order.customer_id : false,
          this.entity.subscription ? this.entity.subscription.customer_id : false,
        ].filter(e => e !== false)

        return possibilities.length ? possibilities[0] : false
      },
      formatQpDate (date) {
        return this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
      },
      formatCard (card) {
        return card ? card.match(/.{4}/g).join(' ') : ''
      },
      labelUrl: function (orderLine) {
        return `${URL_PREFIX}/panel/shippinglabels/${orderLine.orderable.package_number}/label`
      },
      cancel: function () {
        if (this.locked) { return false }

        this.locked = true

        if (confirm(`${this.$t('confirm_cancellation')} ${this.$t('subscription')}`)) {
          this.loading = true
          const params = {
            with: ['customer'],
          }
          this.$patch(`${this.endpoint}/${this.subscription_id}`, params, {
            action: 'cancel',
          })
            .then(({ data }) => {
              data.success
                ? this.$toast(data.message || this.$t('action_succeeded'))
                : handleErrorResponse(data.message || this.$t('action_failed'))

              this.load(true)
              this.locked = false
            })
            .catch(e => {
              this.locked = false
              return Promise.reject(e)
            })
            .catch(handleErrorResponse)
        }
      },
      refundShipment: function (orderLine, insurance) {
        this.refundAmount = (orderLine.sales_price_incl_vat + (insurance ? insurance.sales_price_incl_vat : 0)).toFixed(2)

        this.refund()
      },
    },
  }
</script>
<style scoped>
.v-data-iterator .v-card {
  box-shadow: initial;
}
</style>
